const isStoreNameFilter = (name) => {
    if(name && ["appClientIdList", "appClientId"].includes(name)) {
        return true
    }
    return false
}
module.exports = {
    isStoreNameFilter
}